import React from 'react';
import {LineupStackExtractor as TeamStackExtractor} from 'components/organisms/nhl-team-stacking/services/lineup-stack-extractor';
import NhlTeamStackingMarker from 'components/organisms/nhl-team-stacking/services/nhl-team-stacking-marker';
import {LineupStackExtractor as LegacyTeamStackExtractor} from 'components/organisms/nhl-legacy-team-stacking/services/lineup-stack-extractor';
import NhlLegacyTeamStackingMarker from 'components/organisms/nhl-legacy-team-stacking/services/nhl-legacy-team-stacking-marker';
import {LineupPlayers as BaseLineupPlayers} from 'components/organisms/lineup/components/lineup-players';

class LineupPlayersSketch extends BaseLineupPlayers {
    constructor(props) {
        super(props);
        const {lineupId, rawLineups, nhlTeamStacking, nhlLegacyTeamStacking} = props;

        const simplexLineup = rawLineups.getLineup(lineupId);

        if (nhlTeamStacking.isEnabled()) {
            this.stackPlayerAnalyzer = new TeamStackExtractor(
                simplexLineup.getOriginalLineup(),
                nhlTeamStacking,
                NhlTeamStackingMarker,
            );
        } else if (nhlLegacyTeamStacking.isEnabled()) {
            this.stackPlayerAnalyzer = new LegacyTeamStackExtractor(
                simplexLineup.getOriginalLineup(),
                NhlLegacyTeamStackingMarker,
            );
        }
    }

    getStackClassName(player) {
        if (!('stackPlayerAnalyzer' in this)) {
            return '';
        }

        if (this.stackPlayerAnalyzer.isPlayerFromFirstStack(player)) {
            return 'primary-stack-color';
        } else if (this.stackPlayerAnalyzer.isPlayerFromSecondStack(player)) {
            return 'secondary-stack-color';
        } else if (this.stackPlayerAnalyzer.isPlayerFromThirdStack(player)) {
            return 'third-stack-color';
        }

        return '';
    }
}

export {LineupPlayersSketch};
